/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";
import {
  X,
  LayoutDashboard,
  Check,
  RefreshCw,
  Lock,
  Info,
  Key,
  Globe,
  Database,
  BarChart,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationEcomanger({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.AccountReducer);
  const products = useSelector((state) => state.ProductsReducer);
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const [data, setData] = useStoreFormDraft(store);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, ecomangerActive: !data.ecomangerActive });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if Ecomanger service is activated
    if (!data.ecomangerActive) {
      await showAlert(
        "warning",
        t("servicePageActivation.ecomanager.alerts.notActivated.title"),
        t("servicePageActivation.ecomanager.alerts.notActivated.text")
      );
      return;
    }

    // Validation
    if (data.ecomangerActive) {
      if (!data.Secomanager || !data.ecomanager) {
        await showAlert(
          "warning",
          t("servicePageActivation.ecomanager.alerts.missingData.title"),
          t("servicePageActivation.ecomanager.alerts.missingData.text")
        );
        return;
      }
    }

    try {
      setLoading(true);
      apicache(account, products);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);

      await showAlert(
        "success",
        t("servicePageActivation.ecomanager.alerts.success.text")
      );
      close();
    } catch (error) {
      setLoading(false);

      await showAlert(
        "error",
        t("servicePageActivation.ecomanager.alerts.error.title"),
        t("servicePageActivation.ecomanager.alerts.error.text")
      );

      console.error("Error saving Ecomanger settings:", error);
    }
  };

  const handleDisable = async (e) => {
    e.preventDefault();

    // Vérifier si la plateforme est déjà désactivée
    if (!data.ecomanager) {
      await Swal.fire({
        icon: "info",
        title: t(
          "servicePageActivation.ecomanager.alerts.alreadyDisabled.title"
        ),
        text: t("servicePageActivation.ecomanager.alerts.alreadyDisabled.text"),
      });
      return;
    }

    try {
      setLoading(true);

      // Mettre à jour les données (désactivation)
      const updatedData = {
        ...data,
        Secomanager: "",
        ecomanager: "",
        ecomangerActive: false,
      };

      await saveStoreDraft(doc(db, "store", data.id), store, updatedData);
      dispatch(applyStoreDraft(store, updatedData));

      setLoading(false);

      await Swal.fire({
        icon: "success",
        title: t("servicePageActivation.ecomanager.alerts.disabled.title"),
        text: t("servicePageActivation.ecomanager.alerts.disabled.text"),
      });

      // Mettre à jour l'état local si nécessaire
      setData(updatedData);
    } catch (error) {
      setLoading(false);

      await Swal.fire({
        icon: "error",
        title: t("servicePageActivation.ecomanager.alerts.disableError.title"),
        text: t("servicePageActivation.ecomanager.alerts.disableError.text"),
      });

      console.error("Error disabling Ecomanger:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.ecomanager.alerts.paidFeature.title"),
      t("servicePageActivation.ecomanager.alerts.paidFeature.text"),
      true,
      t("servicePageActivation.ecomanager.alerts.paidFeature.confirmText")
    );

    if (result.isConfirmed) {
      window.location.href = "/plan";
    }
  };

  // Ecomanger benefits
  const ecomangerBenefits = [
    {
      title: t("servicePageActivation.ecomanager.benefits.0.title"),
      description: t("servicePageActivation.ecomanager.benefits.0.description"),
      icon: <Database className="text-[#9e68ba]" size={20} />,
    },
    {
      title: t("servicePageActivation.ecomanager.benefits.1.title"),
      description: t("servicePageActivation.ecomanager.benefits.1.description"),
      icon: <BarChart className="text-blue-500" size={20} />,
    },
    {
      title: t("servicePageActivation.ecomanager.benefits.2.title"),
      description: t("servicePageActivation.ecomanager.benefits.2.description"),
      icon: <LayoutDashboard className="text-green-500" size={20} />,
    },
  ];

  // If feature is locked, show lock screen
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#3c3a3d]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3">
              {t("servicePageActivation.ecomanager.lockedTitle")}
            </h3>
            <p className="text-gray-600 mb-6 max-w-md mx-auto dark:!text-gray-300">
              {t("servicePageActivation.ecomanager.lockedDescription")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.ecomanager.lockedButton")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] dark:!bg-[#181819] dark:!border-[#3c3a3d]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <LayoutDashboard className="ml-2" size={20} />
            {t("servicePageActivation.ecomanager.title")}
          </h3>
          <p className="text-gray-600 mb-4 dark:!text-gray-300">
            {t("servicePageActivation.ecomanager.description")}
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 rounded-lg border border-blue-200 p-4 flex mb-6 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
            <Info size={20} className="text-blue-500 ml-2 flex-shrink-0 mt-1" />
            <div>
              <p className="font-medium text-blue-800 mb-1 dark:!text-blue-400">
                {t("servicePageActivation.ecomanager.infoBox.title")}
              </p>
              <p className="text-blue-700 text-sm dark:!text-blue-300">
                {t("servicePageActivation.ecomanager.infoBox.description")}
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <label className="block text-sm font-medium text-[#9e68ba] mb-4">
              {t("servicePageActivation.ecomanager.toggle.label")}
            </label>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d] ${
                data.ecomangerActive
                  ? "bg-[#fcf6ff] border-purple-200"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]"
              }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none ">
                <input
                  type="checkbox"
                  checked={data.ecomangerActive}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle"
                />
                <label
                  htmlFor="toggle"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.ecomangerActive ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 rounded-full bg-white shadow transform transition-transform duration-200 ease-in ${
                      data.ecomangerActive
                        ? "rtl:-translate-x-6 ltr:translate-x-6"
                        : "translate-x-0"
                    }`}
                  />
                </label>
              </div>
              <div>
                <p className="font-medium dark:!text-gray-200">
                  {data.ecomangerActive
                    ? t("servicePageActivation.ecomanager.toggle.enabled.title")
                    : t(
                        "servicePageActivation.ecomanager.toggle.disabled.title"
                      )}
                </p>
                <p className="text-sm text-gray-500 dark:!text-gray-400">
                  {data.ecomangerActive
                    ? t(
                        "servicePageActivation.ecomanager.toggle.enabled.description"
                      )
                    : t(
                        "servicePageActivation.ecomanager.toggle.disabled.description"
                      )}
                </p>
              </div>
            </div>
          </div>

          {/* API Configuration */}
          {data.ecomangerActive && (
            <div className="space-y-4">
              <h4 className="font-medium text-[#9e68ba]">
                {t("servicePageActivation.ecomanager.information")}
              </h4>

              {/* Subdomain Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.ecomanager.form.subdomain.label")}
                </label>
                <input
                  type="text"
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d] dark:!text-gray-200"
                  placeholder={t(
                    "servicePageActivation.ecomanager.form.subdomain.placeholder"
                  )}
                  value={data.Secomanager || ""}
                  onChange={(e) =>
                    setData({ ...data, Secomanager: e.target.value })
                  }
                />
                <p className="text-xs text-gray-500 dark:!text-gray-400">
                  {t(
                    "servicePageActivation.ecomanager.form.subdomain.description"
                  )}
                </p>
              </div>

              {/* API Key Input */}
              <div className="space-y-2">
                <label className="block text-sm font-medium text-gray-700 dark:!text-gray-300">
                  {t("servicePageActivation.ecomanager.form.apikey.label")}
                </label>
                <input
                  type="text"
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d] dark:!text-gray-200"
                  placeholder={t(
                    "servicePageActivation.ecomanager.form.apikey.placeholder"
                  )}
                  value={data.ecomanager || ""}
                  onChange={(e) =>
                    setData({ ...data, ecomanager: e.target.value })
                  }
                />
                <p className="text-xs text-gray-500 dark:!text-gray-400">
                  {t(
                    "servicePageActivation.ecomanager.form.apikey.description"
                  )}
                </p>
              </div>
            </div>
          )}

          {/* Features */}
          {data.ecomangerActive && (
            <div className="space-y-4 mt-6">
              <h4 className="font-medium text-[#9e68ba]">
                {t("servicePageActivation.ecomanager.features.title")}
              </h4>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {ecomangerBenefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-lg p-4 border border-gray-200 shadow-sm dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]"
                  >
                    <div className="flex items-center mb-2">
                      {benefit.icon}
                      <h5 className="font-medium text-gray-800 mr-2 text-sm dark:!text-gray-200">
                        {benefit.title}
                      </h5>
                    </div>
                    <p className="text-xs text-gray-600 dark:!text-gray-400">
                      {benefit.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Tips */}
          <div className="bg-yellow-50 p-4 rounded-lg border border-yellow-100 dark:!bg-[#2a2a2a] dark:!border-[#3c3a3d]">
            <h4 className="font-medium text-lg text-yellow-800 mb-2 flex items-center dark:!text-yellow-400">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.ecomanager.tips.title")}
            </h4>
            <ul className="text-sm text-gray-700 space-y-2 mr-5 list-disc dark:!text-gray-300">
              <li>{t("servicePageActivation.ecomanager.tips.items.0")}</li>
              <li>{t("servicePageActivation.ecomanager.tips.items.1")}</li>
              <li>{t("servicePageActivation.ecomanager.tips.items.2")}</li>
              <li>{t("servicePageActivation.ecomanager.tips.items.3")}</li>
            </ul>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-between mt-4">
            <button
              type="submit"
              disabled={loading}
              className={`px-6 py-3 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors flex items-center ${
                loading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {loading ? (
                <>
                  <RefreshCw className="animate-spin ml-2" size={18} />
                  {t("servicePageActivation.ecomanager.buttons.saving")}
                </>
              ) : (
                <>
                  <Check className="ml-2" size={18} />
                  {t("servicePageActivation.ecomanager.buttons.save")}
                </>
              )}
            </button>
            <Button
              variant="danger"
              className="d-flex align-items-center justify-content-center"
              onClick={handleDisable}
              style={{
                borderRadius: "0.5rem",
                padding: "0.5rem 1.5rem",
                minWidth: "150px",
              }}
            >
              <X className="ml-2" size={18} />
              {t("servicePageActivation.ecomanager.buttons.disable")}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
